<template>
    <v-card
        outlined
        class="mt-4 admin-steffi-booking-card"
        data-test="steffi-admin-booking-card"
    >
        <v-row>
            <v-col cols="12" lg="9">
                <v-card-title class="v-application">
                    <span>Steffi hinzufügen</span>
                </v-card-title>

                <v-card-text>
                    <v-btn-toggle
                        v-model="adminBookingMode"
                        color="blue accent-3"
                        class="mr-2"
                        mandatory
                        data-test="steffi-admin-booking-mode"
                    >
                        <v-btn small height="40" value="invite">Einladung per E-Mail senden</v-btn>
                        <v-btn small height="40" value="offline">Vertragsset wurde offline angenommen</v-btn>
                        <v-btn small height="40" value="existing">Bestandsvertrag importieren</v-btn>
                    </v-btn-toggle>
                </v-card-text>
                <v-card-text class="v-application--is-ltr">
                    <v-row class="v-application" dense>
                        <template v-if="adminBookingMode == 'invite'">
                            <v-col cols="12" md="4">
                                <v-select
                                    v-model="adminInvitationForm.plan_code"
                                    :items="planItems"
                                    dense
                                    outlined
                                    label="Paket"
                                    hide-details
                                    data-test="steffi-admin-invitation-plan"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="adminInvitationForm.invited_email"
                                    dense
                                    outlined
                                    type="email"
                                    label="Empfänger E-Mail"
                                    class="mr-2"
                                    hide-details
                                    data-test="steffi-admin-invitation-email"
                                ></v-text-field>
                            </v-col>
                        </template>

                        <template v-else-if="adminBookingMode == 'offline'">
                            <v-col cols="12" md="4">
                                <v-select
                                    v-model="adminBookingForm.plan_code"
                                    :items="planItems"
                                    dense
                                    outlined
                                    label="Paket"
                                    hide-details
                                    data-test="steffi-admin-booking-plan"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="adminBookingForm.accepted_at"
                                    dense
                                    outlined
                                    type="date"
                                    label="Vertrags-/Annahmedatum"
                                    class="mr-2"
                                    hide-details
                                    data-test="steffi-admin-booking-date"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-checkbox
                                    v-model="adminBookingForm.trial_requested"
                                    dense
                                    hide-details
                                    label="Mit kostenloser 14-tägiger Testphase starten"
                                    data-test="steffi-admin-booking-trial"
                                ></v-checkbox>
                            </v-col>
                            <v-col cols="12">
                                <v-checkbox
                                    v-model="adminBookingForm.accepted_contract_terms"
                                    dense
                                    hide-details
                                    label="Das Vertragsset einschließlich Nutzungsbedingungen, Preisen, AVV/Datenschutz und Abrechnung wurde angenommen."
                                    data-test="steffi-admin-booking-contract"
                                ></v-checkbox>
                            </v-col>
                            <v-col cols="12">
                                <v-textarea
                                    v-model="adminBookingForm.internal_note"
                                    dense
                                    outlined
                                    auto-grow
                                    rows="2"
                                    hide-details
                                    label="Interne Notiz"
                                    data-test="steffi-admin-booking-note"
                                ></v-textarea>
                            </v-col>
                        </template>

                        <template v-else>
                            <v-col cols="12">
                                <v-alert type="info" outlined dense>
                                    Die bisherigen Rechnungen werden nicht erneut erzeugt. Ab dem automatischen
                                    Abrechnungsbeginn gelten dauerhaft die hier erfassten Vertragspreise.
                                </v-alert>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-select
                                    v-model="existingCustomerForm.plan_code"
                                    :items="planItems"
                                    dense outlined hide-details label="Paket"
                                    data-test="steffi-existing-plan"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="existingCustomerForm.accepted_at"
                                    dense outlined hide-details type="date" label="Startdatum des Bestandsvertrags"
                                    data-test="steffi-existing-start-date"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="existingCustomerForm.automated_billing_start_date"
                                    dense outlined hide-details type="date" label="Automatische Abrechnung ab"
                                    data-test="steffi-existing-billing-start-date"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="existingCustomerForm.setup_net"
                                    dense outlined hide-details inputmode="decimal" suffix="€ netto"
                                    label="Einrichtungspreis laut Vertrag"
                                    data-test="steffi-existing-setup-net"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="existingCustomerForm.monthly_net"
                                    dense outlined hide-details inputmode="decimal" suffix="€ netto"
                                    label="Monatspreis laut Vertrag"
                                    data-test="steffi-existing-monthly-net"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="existingCustomerForm.usage_minute_net"
                                    dense outlined hide-details inputmode="decimal" suffix="€ netto"
                                    label="Minutenpreis laut Vertrag"
                                    data-test="steffi-existing-usage-net"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-textarea
                                    v-model="existingCustomerForm.internal_note"
                                    dense outlined auto-grow rows="2" hide-details label="Interne Notiz"
                                    data-test="steffi-existing-note"
                                ></v-textarea>
                            </v-col>
                        </template>
                    </v-row>
                </v-card-text>
                <v-card-actions class="d-flex justify-center">
                    <v-row v-if="adminBookingMode == 'invite'" class="d-flex align-center">
                        <v-col cols="12">
                            <v-alert type="success" dense text class="mb-0 mx-3 v-application--is-ltr body-2">
                                Die Apotheke bestätigt das vollständige Vertragsset einschließlich
                                Nutzungsbedingungen, Preisen, AVV/Datenschutz und Abrechnung über den Link.
                            </v-alert>
                        </v-col>
                        <v-col cols="12" class="text-center">
                            <v-btn
                                width="335"
                                class="mb-2"
                                color="primary"
                                :disabled="!canSendAdminInvitation"
                                :loading="isSendingAdminInvitation"
                                data-test="steffi-admin-invitation-submit"
                                @click="sendAdminInvitation"
                            >
                                Einladung senden
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-btn
                        v-else
                        color="primary"
                        :disabled="!canSubmitCurrentBooking"
                        :loading="isCreatingAdminBooking"
                        data-test="steffi-admin-booking-submit"
                        @click="createAdminBooking"
                        width="335"
                        class="mb-2"
                    >
                        {{ adminBookingMode == 'existing' ? 'Bestandsvertrag importieren' : 'Steffi hinzufügen' }}
                    </v-btn>
                </v-card-actions>
            </v-col>

            <v-col cols="12" lg="3" class="d-flex align-center pr-7">
                <v-alert color="cyan darken-2" dense outlined class="mt-2 mb-0 v-application--is-ltr">
                    <v-icon color="cyan" class="mr-1 mb-1">mdi-information</v-icon>
                    <span class="body-2">
                        Wählen Sie, ob die Apotheke das Vertragsset selbst bestätigen soll oder ob es
                        bereits offline angenommen wurde. Bei einer Einladung wird noch keine Rechnung
                        ausgelöst; bei der Offline-Annahme ohne Testphase wird die Buchung mit
                        Einrichtungsrechnung zum Annahmedatum angelegt. Mit Testphase erfolgt die
                        Abrechnung erst nach einer späteren kostenpflichtigen Buchung. Die technische
                        Aktivierung erfolgt separat.
                    </span>
                </v-alert>
            </v-col>

        </v-row>

    </v-card>
</template>
<script>
import { mapMutations } from 'vuex';
import axios from 'axios';

const currentMonthStart = () => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-01`;
};

export default {
    name: 'SteffiAdminOnboarding',
    props: {
        pharmacyId: {
            type: String,
            required: true,
        },
        context: {
            type: Object,
            default: null,
        },
        routeGeneration: {
            type: Number,
            required: true,
        },
    },
    emits: ['context-updated'],
    data: () => ({
        adminBookingMode: 'invite',
        adminInvitationForm: {
            plan_code: 'base',
            invited_email: '',
        },
        adminBookingForm: {
            plan_code: 'base',
            accepted_at: new Date().toISOString().slice(0, 10),
            accepted_contract_terms: false,
            trial_requested: false,
            internal_note: '',
        },
        existingCustomerForm: {
            plan_code: 'base',
            accepted_at: '',
            automated_billing_start_date: currentMonthStart(),
            setup_net: '',
            monthly_net: '',
            usage_minute_net: '0,20',
            internal_note: '',
        },
        planItems: [
            { text: 'Basis', value: 'base' },
            { text: 'Premium', value: 'premium' },
        ],
        isCreatingAdminBooking: false,
        isSendingAdminInvitation: false,
        isActive: true,
    }),
    computed: {
        canSubmitAdminBooking() {
            return Boolean(
                this.adminBookingForm.plan_code
                && this.adminBookingForm.accepted_at
                && this.adminBookingForm.accepted_contract_terms
                && !this.isCreatingAdminBooking,
            );
        },
        canSendAdminInvitation() {
            return Boolean(
                this.adminInvitationForm.plan_code
                && this.adminInvitationForm.invited_email
                && !this.isSendingAdminInvitation,
            );
        },
        canImportExistingCustomer() {
            return Boolean(
                this.existingCustomerForm.plan_code
                && this.existingCustomerForm.accepted_at
                && this.existingCustomerForm.automated_billing_start_date
                && this.existingCustomerForm.setup_net !== ''
                && this.existingCustomerForm.monthly_net !== ''
                && this.existingCustomerForm.usage_minute_net !== ''
                && !this.isCreatingAdminBooking,
            );
        },
        canSubmitCurrentBooking() {
            return this.adminBookingMode == 'existing'
                ? this.canImportExistingCustomer
                : this.canSubmitAdminBooking;
        },
    },
    methods: {
        isCurrentAction(pharmacyId, routeGeneration) {
            return this.isActive
                && this.pharmacyId === pharmacyId
                && this.routeGeneration === routeGeneration;
        },
        async sendAdminInvitation() {
            if (!this.pharmacyId || !this.canSendAdminInvitation) return;
            const pharmacyId = this.pharmacyId;
            const routeGeneration = this.routeGeneration;
            try {
                this.isSendingAdminInvitation = true;
                const response = await axios.post(
                    `/api/pharmacies/${pharmacyId}/steffi/admin-invitations`,
                    {
                        plan_code: this.adminInvitationForm.plan_code,
                        invited_email: this.adminInvitationForm.invited_email,
                    },
                );
                if (!this.isCurrentAction(pharmacyId, routeGeneration)) return;
                this.$emit('context-updated', response.data, pharmacyId, routeGeneration);
                this.alertSuccess('Steffi Einladung wurde versendet');
            } catch (error) {
                if (!this.isCurrentAction(pharmacyId, routeGeneration)) return;
                this.alertError(error?.response?.data?.message || 'Steffi Einladung konnte nicht versendet werden.');
            } finally {
                if (this.isCurrentAction(pharmacyId, routeGeneration)) this.isSendingAdminInvitation = false;
            }
        },
        async createAdminBooking() {
            if (!this.pharmacyId || !this.canSubmitCurrentBooking) return;
            const pharmacyId = this.pharmacyId;
            const routeGeneration = this.routeGeneration;
            try {
                this.isCreatingAdminBooking = true;
                const existingCustomerImport = this.adminBookingMode == 'existing';
                const payload = existingCustomerImport
                    ? {
                        ...this.existingCustomerForm,
                        existing_customer_import: true,
                        source: 'admin_legacy_contract_import',
                    }
                    : {
                        plan_code: this.adminBookingForm.plan_code,
                        accepted_at: this.adminBookingForm.accepted_at,
                        accepted_contract_terms: this.adminBookingForm.accepted_contract_terms,
                        trial_requested: this.adminBookingForm.trial_requested,
                        internal_note: this.adminBookingForm.internal_note,
                        source: 'admin_offline_contract',
                    };
                const response = await axios.post(
                    `/api/pharmacies/${pharmacyId}/steffi/admin-booking`,
                    payload,
                );
                if (!this.isCurrentAction(pharmacyId, routeGeneration)) return;
                this.$emit('context-updated', response.data, pharmacyId, routeGeneration);
                this.adminBookingForm.accepted_contract_terms = false;
                this.alertSuccess(existingCustomerImport
                    ? 'Bestandsvertrag wurde importiert'
                    : 'Steffi Onboarding wurde angelegt');
            } catch (error) {
                if (!this.isCurrentAction(pharmacyId, routeGeneration)) return;
                this.alertError(error?.response?.data?.message || 'Steffi Onboarding konnte nicht angelegt werden.');
            } finally {
                if (this.isCurrentAction(pharmacyId, routeGeneration)) this.isCreatingAdminBooking = false;
            }
        },
        syncAdminInvitationForm() {
            if (!this.context?.pharmacy?.invitation_email || this.adminInvitationForm.invited_email) {
                return;
            }
            this.adminInvitationForm.invited_email = this.context.pharmacy.invitation_email;
        },
        ...mapMutations({
            alertSuccess: 'alert/success',
            alertError: 'alert/error',
        }),
    },
    created() {
        this.syncAdminInvitationForm();
    },
    beforeDestroy() {
        this.isActive = false;
    },
    watch: {
        context() {
            this.syncAdminInvitationForm();
        },
        routeGeneration() {
            this.isCreatingAdminBooking = false;
            this.isSendingAdminInvitation = false;
        },
    },
}
</script>

<style scoped>
.admin-steffi-booking-card {
    height: auto !important;
}
</style>
